<template>
    <div id="tlk-abbonamento-sidebar" class="d-none d-md-block col-4">
        <h5 class="mb-4">Riepilogo</h5>
        <div class="text-uppercase my-3 d-flex align-items-center border-bottom pb-3">
            <span class="d-inline-flex justify-content-center align-content-center me-2" :class="{ 'text-primary': durata, 'text-secondary-emphasis': !durata }">
                <span class="icon-ico-clock fs-5"></span>
            </span>	
            <span class="fs-xs font-alt" :class="{ 'text-light': durata, 'text-secondary-emphasis': !durata }">
                <span>durata</span>
            </span>
            <span class="fs-xs font-alt ms-auto">
                <span>{{ durata }}</span>
            </span>
        </div>
        <div class="text-uppercase my-3 d-flex align-items-center border-bottom pb-3">
            <span class="d-inline-flex justify-content-center align-content-center me-2" :class="{ 'text-primary': tipo, 'text-secondary-emphasis': !tipo }">
                <span class="icon-ico-menutype fs-5"></span>
            </span>	
            <span class="fs-xs font-alt" :class="{ 'text-light': tipo, 'text-secondary-emphasis': !tipo }">
                <span>tipo menu</span>
            </span>
            <span class="fs-xs font-alt ms-auto">
                <span>{{ tipo }}</span>
            </span>
        </div>
        <div class="text-uppercase my-3 d-flex align-items-center border-bottom pb-3">
            <span class="d-inline-flex justify-content-center align-content-center me-2" :class="{ 'text-primary': obiettivi, 'text-secondary-emphasis': !obiettivi }">
                <span class="icon-ico-attributes fs-5"></span>
            </span>	
            <span class="fs-xs font-alt" :class="{ 'text-light': obiettivi, 'text-secondary-emphasis': !obiettivi }">
                <span>obiettivi</span>
            </span>
            <span class="fs-xs font-alt ms-auto">
                <span>{{ obiettivi }}</span>
            </span>
        </div>
        <div class="text-uppercase my-3 d-flex align-items-center border-bottom pb-3">
            <span class="d-inline-flex justify-content-center align-content-center me-2" :class="{ 'text-primary': allergeni, 'text-secondary-emphasis': !allergeni }">
                <span class="icon-ico-attributes fs-5"></span>
            </span>	
            <span class="fs-xs font-alt" :class="{ 'text-light': allergeni, 'text-secondary-emphasis': !allergeni }">
                <span>allergeni</span>
            </span>
            <span class="fs-xs font-alt ms-auto">
                <span>{{ allergeni }}</span>
            </span>
        </div>
        <div class="text-uppercase my-3 d-flex align-items-center border-bottom pb-3">
            <span class="d-inline-flex justify-content-center align-content-center me-2" :class="{ 'text-primary': piatti, 'text-secondary-emphasis': !piatti }">
                <span class="icon-ico-piatti fs-5"></span>
            </span>	
            <span class="fs-xs font-alt" :class="{ 'text-light': piatti, 'text-secondary-emphasis': !piatti }">
                <span>scelta piatti</span>
            </span>
            <span class="fs-xs font-alt ms-auto">
                <span v-if="showPiatti"><span class="text-primary">{{ piatti }}</span> di {{ nummandatory }} selezionati</span>
            </span>
        </div>

    </div>
</template>

<script>
import { isNil, replace } from 'lodash';
export default {
    name: 'SideBar',
    data(){
        return {
        }
    },
    computed: {
        selected(){
            return this.$store.state.abbonamento.products;
        },
        durata(){
            const subscriptions = this.$store.state.subscriptions;
            const subscription = this.$store.state.abbonamento.subscription;

            if (isNil(subscriptions))
                return '';

            let varobj = subscriptions.filter(varo => varo.id == subscription);

            if (varobj.length > 0) {
                return varobj[0].name;
            } else {
                return '';
            }
        },
        tipo() {
            
            const variations = this.$store.state.variations;
            const variation = this.$store.state.abbonamento.variation;

            if(isNil(variation))
                return '';

            let varobj = variations.filter(varo => varo.id == variation);

            if (varobj.length > 0) {
                return replace(varobj[0].piano, '-', ' ');
            } else {
                return '';
            }
        },
        obiettivi(){
            const ob = this.$store.state.abbonamento.obiettivi.length;
            if (ob < 1) return 'Nessuno';
            return ob > 1 ? ob + ' selezionati' : ob + ' selezionato';
        },
        allergeni(){
            const al = this.$store.state.abbonamento.allergeni.length;
            if (al < 1) return 'Nessuno';
            return al > 1 ? al + ' selezionati' : al + ' selezionato';
        },
        showPiatti(){
            return this.piatti;
        },
        piatti(){
            if (this.selected.length > 0)
                return this.selected.map(i => i.quantity).reduce((a, b) => parseInt(a) + parseInt(b));
            else
                return 0;
        },
        ndays() {
            const variations = this.$store.state.variations;
            const variation = this.$store.state.abbonamento.variation;

            let varobj = variations.filter(varo => varo.id == variation);

            if (varobj.length > 0) {
                return varobj[0].piano.split('-');
            } else {
                return ['half', 5];
            }
        },
        nummandatory() {
            const days = parseInt(this.ndays[1]);
            const timeDay = this.ndays[0] == 'half' ? 1 : 2;
            return days + (days * timeDay);
        }
    }
};
</script>